/**
 * @flow
 * @relayHash fc82743d497e87920ca735ba252d03a4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProductWhere = {|
  and?: ?$ReadOnlyArray<?ProductWhere>,
  or?: ?$ReadOnlyArray<?ProductWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  name?: ?ConditionInputType,
  description?: ?ConditionInputType,
  hasVariablePrice?: ?ConditionInputType,
  price?: ?ConditionInputType,
  isInternet?: ?ConditionInputType,
  requiresCpe?: ?ConditionInputType,
  isAsistencia?: ?ConditionInputType,
  uploadSpeed?: ?ConditionInputType,
  downloadSpeed?: ?ConditionInputType,
  isDisabled?: ?ConditionInputType,
  displayName?: ?ConditionInputType,
  isService?: ?ConditionInputType,
  isConsumo?: ?ConditionInputType,
  accountId?: ?ConditionInputType,
  type?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  hasDigital?: ?ConditionInputType,
  hasCatv?: ?ConditionInputType,
  familyId?: ?ConditionInputType,
  subscriptions?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type ProductSelectQueryVariables = {|
  where?: ?ProductWhere
|};
export type ProductSelectQueryResponse = {|
  +products: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |}
|};
export type ProductSelectQuery = {|
  variables: ProductSelectQueryVariables,
  response: ProductSelectQueryResponse,
|};
*/


/*
query ProductSelectQuery(
  $where: ProductWhere
) {
  products(where: $where, orderBy: [code], order: ASC) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "ProductWhere",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "products",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "order",
        "value": "ASC"
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": [
          "code"
        ]
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "ProductConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Product",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProductSelectQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ProductSelectQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ProductSelectQuery",
    "id": null,
    "text": "query ProductSelectQuery(\n  $where: ProductWhere\n) {\n  products(where: $where, orderBy: [code], order: ASC) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8cc4a5bb9b533a497e9c7f3401d6f46a';
module.exports = node;
